import { Modal } from 'bootstrap';

// Po wysłaniu formularza kontaktowego pokazujemy modal podziękowań
// (makieta Figma 200:210) — ten sam komponent co modale zgłoszenia.
// Formularz jest resetowany w ajax-form.js (nie robimy preventDefault).
$('.contact-form').on('submit-success', function(event, data, xhr) {
    event.assert(xhr.status == 201 && data.status == 'OK');

    const el = document.getElementById('contactSuccessModal');
    if (el) {
        Modal.getOrCreateInstance(el).show();
    }
});
